import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/t2.png")